import React from 'react';
import { get } from 'lodash';
import './ReduxFormStyles.scss';
import { Col, ControlLabel, FormGroup } from 'react-bootstrap';

const RadioGroup = ({
  input,
  label,
  labelSize,
  infoButton,
  options,
  objectKey,
  inline,
  marginTop10,
  marginTop15,
  width,
  isDisabled,
}) => {
  const classname = [
    'radio-container',
    inline && 'inline',
    marginTop10 && 'margin-top10',
    marginTop15 && 'margin-top15',
    isDisabled && 'radio-container--disabled',
  ];

  const renderRadioGroup = (
    <div className={'margin-top-10'}>
      {options.map((option, key) => {
        const value = objectKey ? get(option.value, objectKey) : option.value;

        const onBlur = () => input.onBlur(value);
        const onChange = () => {
          if (!isDisabled) {
            input.onChange(value);
          }
        };

        const complexValueOverrides = { onBlur, onChange };

        return (
          <div
            className={classname.join(' ')}
            key={key}
            style={width ? { width: width } : {}}
          >
            <div className={'form-radio'}>
              <input
                {...input}
                {...complexValueOverrides}
                type="radio"
                id={`${input.name}.${option.value}`.replaceAll('.', '_')}
                value={option.value}
                checked={input.value === value}
                disabled={isDisabled}
              />
              <label htmlFor={`${input.name}.${option.value}`.replaceAll('.', '_')} />
            </div>
            <div className="radio-label" onClick={onChange}   id={`${input.name}.${option.value}_label`.replaceAll('.', '_')}>
              {option.label}
            </div>
          </div>
        );
      })}
    </div>
  );

  if (label) {
    const labelSmSize = labelSize || 2;
    const componentSize = 12 - labelSmSize;
    return (
      <FormGroup>
        <Col sm={labelSmSize}>
          <ControlLabel>
            {label} {infoButton}
          </ControlLabel>
        </Col>
        <Col sm={componentSize}>{renderRadioGroup}</Col>
      </FormGroup>
    );
  }
  return renderRadioGroup;
};

export default RadioGroup;
